<template>
  <div class="editor">
    <div class="panel-topnav">
      <router-link
        v-show="user.isAdmin"
        :to="cameFromUrl ? { path: cameFromUrl } : { name: 'adminStartupList' }"
        class="back-link pull-left"
      >
        <i class="ion-ios-arrow-back text-yellow before"></i> Startups
      </router-link>
      <div class="panel-controls pull-left">
        <a href class="btn btn-primary" @click.prevent="save()">
          Save changes
        </a>
        <a
          v-if="!startup.profile_locked"
          :href="startupProfileLink"
          class="btn btn-primary"
          target="_preview"
          >Preview</a
        >
        <el-badge value="beta" type="primary" v-if="user.isAdmin">
          <a
            :href="newAdminEditorUrl"
            class="btn btn-primary"
            target="_new_editor"
            >New editor</a
          >
        </el-badge>
        <el-badge
          value="beta"
          type="primary"
          v-if="$hasFeature('STARTUP_NEW_EDITOR')"
        >
          <a :href="newEditorUrl" class="btn btn-primary" target="_new_editor"
            >New editor</a
          >
        </el-badge>
      </div>
      <div class="panel-controls pull-right">
        <Fader ref="saveIndicator">
          <p class="text-success">Saved</p>
        </Fader>
      </div>
      <div class="clearfix"></div>
    </div>

    <StartupProfile
      v-if="(user.isStartup && !startup.profile_locked) || user.isAdmin"
      ref="profile"
      v-loadcover="fetchInProgress"
      :editable="true"
      :startup="startup"
      :can-user-see-private-data="true"
    />

    <div v-if="user.isStartup && startup.profile_locked" class="locked-info">
      <h3><i class="ion ion-locked"></i> Locked</h3>

      <p>
        Company's profile would become visible once you finish application
        submission.
      </p>
    </div>
  </div>
</template>

<script>
import StartupProfile from '@/modules/startup-profile/StartupProfile.vue'
import { mapState } from 'vuex'
import Fader from 'components/Fader.vue'
import _ from 'lodash'
import { getNewAppUrl } from 'utils/urls'

export default {
  components: { Fader, StartupProfile },
  props: {
    cameFromUrl: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    startupProfileLink() {
      const name = 'publicStartupProfile'
      const params = { slug: this.startup.slug || this.startup.id || '-' }
      return this.$router.resolve({ name, params }).href
    },
    ...mapState({
      user: (state) => state.user.data,
      startup: (state) => state.startupProfile.startup,
      fetchInProgress: (state) =>
        state.startupProfile.fetchInProgress || state.user.fetchInProgress,
      saveInProgress: (state) => state.startupProfile.saveInProgress,
    }),
    canUserSeePrivateData() {
      const user = this.user
      return user.isAuthorized && user.startupId === this.startup.id
    },
    newAdminEditorUrl() {
      const url = this.$route.path
      const query = this.$route.query
      return getNewAppUrl(url, query)
    },
    newEditorUrl() {
      const url = '/dashboard/new'
      const query = this.$route.query
      return getNewAppUrl(url, query)
    },
  },
  created() {
    this.unsubscribeSaveStartup = this.$store.subscribe((mutation, store) => {
      const shouldSave = isSaveMutation(mutation.type) && this.startup.name
      if (shouldSave) {
        this.debouncedSave()
      }
    })
  },
  destroyed() {
    this.unsubscribeSaveStartup()
  },
  methods: {
    debouncedSave: _.debounce(function () {
      this.save()
    }, 1200),
    async save() {
      // there is no pitch now
      // this.$refs.profile.clearImageEditors()
      // this.$store.dispatch('startupProfile/setPitch', { pitch: this.getPitch() })
      try {
        await this.$store.dispatch('startupProfile/saveChanges')
      } catch (error) {
        // TODO: scroll to first error
        let msg = 'Something went wrong'
        if (this.$store.state.startupProfile.errors.members) {
          msg = 'Some team members data are invalid'
        }
        this.$store.dispatch('notifications/addItem', {
          type: 'danger',
          content: msg,
          timeout: 6000,
        })
        return
      }
      if (this.$refs.saveIndicator) {
        this.$refs.saveIndicator.show()
      }
    },
    // getPitch() {
    //   return this.$refs.profile.getPitch()
    // },
  },
}

const saveMutations = [
  'SET_STARTUP_ATTR',
  'SET_PITCH_SECTION',
  'ADD_TRAILING_PARAGRAPH_TO_SECTION',
  'PITCH_SECTION_MOVED_BACK',
  'PITCH_SECTION_MOVED_FORWARD',
  'ADD_DOCUMENT',
  'REMOVE_DOCUMENT',
  'SET_CURRENT_ROUND_',
  'SET_PREVIOUS_ROUND_',
  'REMOVE_CURRENT_ROUND',
  'REMOVE_PREVIOUS_ROUND',
  'UPDATE_BACKGROUND_IMAGE',
  'REMOVE_FAQ_ELEMENT',
  'REMOVE_FAQ_SECTION',
  'FAQ_SECTION_MOVED_BACK',
  'FAQ_SECTION_MOVED_FORWARD',
  'UPDATE_FAQ_SECTION',
  'UPDATE_FAQ_QUESTION',
  'UPDATE_FAQ_ANSWER',
]
const saveMutationRe = new RegExp(
  saveMutations.map((sm) => `^startupProfile/${sm}`).join('|'),
)

function isSaveMutation(type) {
  for (const saveMutation in saveMutations) {
    if (saveMutationRe.test(type)) {
      return true
    }
  }
  return false
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.editor {
  .panel-controls {
    .fader {
      p {
        height: 40px;
        line-height: 38px;
      }
    }
  }

  .locked-info {
    color: $grey120;
    text-align: center;

    h3 {
      padding: 10px 20px;
      font-size: 2em;
      font-weight: 300;
    }
  }
}
</style>
